import { Box, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import PersonalInfo from "./PersonalInfo";
import ProfilePicture from "./ProfilePicture";
import color from "../../components/utils/Colors";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import CoverPicture from "./CoverPicture";

const EditProfile: React.FC = () => {
  const location = useLocation();
  const [value, setValue] = useState(0); 

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        p: 4,
        pt: 2,
        width: isSmallScreen ? "100%" : "80%",
        margin: "auto",
        // textAlign: "center",
        display:'flex',
        flexDirection:'column'
      }}
    >
      <Typography
        onClick={handleGoBack}
        sx={{
          margin: 0,
          position: "absolute",
          top: isSmallScreen ? "120px" : "140px",
          color: color.firstColor,
          fontSize: "16px",
          fontWeight: "bold",
          left: isSmallScreen ? 10 : 60,
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ChevronLeft></ChevronLeft> Back
      </Typography>

      <Typography
        sx={{
          color: color.firstColor,
          fontSize: isSmallScreen ? "14px" : "26px",
          fontWeight: "bold",
          cursor: "pointer",
          textAlign: "center",
          width: "100%",
          mb:3,
          mt:1.5,
          pb:3,
          borderBottom:'solid 2px',
          borderColor:color.borderColor
        }}
      >
        Edit G2I Profile
      </Typography>

      <Tabs
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: color.borderColor,
          },
          // gap:'20px'
        }}
        value={value}
        onChange={handleChange}
        centered
      >
        <Tab
          style={{
            color: value === 0? color.textColor:'grey',
            textTransform: "none",
            fontWeight: "bold",
            margin:isSmallScreen ? "0px" :  "0 20px", 
            fontSize: isSmallScreen ? "14px" : "20px",
          }}
          label="Personal Info"
        />
        <Tab
          style={{
            color: value === 1? color.textColor:'grey',
            margin:isSmallScreen ? "0px" :  "0 20px", 
            textTransform: "none",
            fontWeight: "bold",
            fontSize: isSmallScreen ? "14px" : "20px",
          }}
          label="Profile Photo"
        />
        <Tab
          style={{
            color: value === 2? color.textColor:'grey',

            textTransform: "none",
            fontWeight: "bold",
            fontSize: isSmallScreen ? "14px" : "20px",
          }}
          label="Cover Photo"
        />
      </Tabs>
      {value === 0 && <PersonalInfo />}
      {value === 1 && <ProfilePicture />}
      {value === 2 && <CoverPicture />}
    </Box>
  );
};

export default EditProfile;
